<app-section-banner [title]="'unsubscribe.banner_title' | translate"
	[backgroundImage]="'assets/img/terms&conditions.jpg' | imageConverter">
</app-section-banner>

<section id="unsubscribe-anchor" class="flex items-center justify-center min-h-screen px-4 sm:px-6 lg:px-8 relative">
	<div class="text-center text-[#020042] max-w-lg lg:max-w-2xl xl:max-w-3xl mx-auto">

		<!-- Message before unsubscribing -->
		<div *ngIf="!isUnsubscribed" class="flex flex-col items-center justify-center">
			<h1 class="text-2xl sm:text-3xl font-bold mb-6">{{ 'unsubscribe.heading_before' | translate }}</h1>

			<p class="text-sm sm:text-base font-extralight leading-loose mb-8">
				{{ 'unsubscribe.description_before_1' | translate }}
			</p>

			<p class="text-sm sm:text-base font-extralight leading-loose mb-6">
				{{ 'unsubscribe.description_before_2' | translate }}
			</p>

			<!-- Display error message if there is one -->
			<div *ngIf="errorMessage" class="text-red-500 text-sm mb-4">
				{{ errorMessage }}
			</div>

			<div class="flex flex-col sm:flex-row justify-center gap-4">
				<!-- Bot�n de cancelar suscripcion -->
				<button (click)="unsubscribe()" aria-label="Confirmar cancelación de suscripción"
					class="px-6 py-3 bg-[#EF5151] text-white font-light text-sm sm:text-base tracking-wide rounded
          hover:bg-[#ffffff] hover:text-[#EF5151] border border-[#EF5151] transition-all flex items-center justify-center gap-2 mt-6" [disabled]="spinnerService.spinnerObservable | async">
					{{ 'unsubscribe.confirm_button' | translate }}
				</button>

				<!-- Cancel subscription button -->
				<a [routerLink]="['/']" role="button" tabindex="0" aria-label="Mantener suscripción y volver al inicio"
					class="px-6 py-3 bg-[#5173EF] text-white font-light text-sm sm:text-base tracking-wide rounded
          hover:bg-white hover:text-[#020042] border border-[#5173EF] transition-all mt-6">
					{{ 'unsubscribe.cancel_button' | translate }}
				</a>
			</div>
		</div>

		<!-- Message after unsubscribing -->
		<div *ngIf="isUnsubscribed" class="animate-fade-in flex flex-col items-center justify-center">
			<h1 class="text-2xl sm:text-3xl font-bold mb-6">{{ 'unsubscribe.heading_after' | translate }}</h1>

			<p class="text-sm sm:text-base font-extralight leading-loose mb-8">
				{{ 'unsubscribe.description_after' | translate }}
			</p>

			<button (click)="goHome()" aria-label="Volver a la página de inicio" class="px-6 py-3 bg-[#5173EF] text-white font-light text-sm sm:text-base tracking-wide rounded
        hover:bg-white hover:text-[#020042] border border-[#5173EF] transition-all mt-6">
				{{ 'unsubscribe.go_home' | translate }}
			</button>
		</div>
	</div>
</section>